export { default } from './InputWithConfirm.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/InputWithConfirm/index.js